/* eslint-disable default-param-last */
import Constants from './Constants.js'

const initialState = {

}

function filter( state = initialState, action ) {
  const group = action.group
  const filters = action.filters || {}

  switch ( action.type ) {
    case Constants.FILTER_ADD: {
      const nState = { ...state }
      nState[group] = state[group] === null ? {} : { ...state[group] }

      // Add filters to current filter state, replacing duplicate keys
      return {
        ...nState,
        [group] : {
          ...nState[group],
          ...filters
        }
      }
    }

    case Constants.FILTER_SET: {

      return {
        ...state,
        [group] : filters
      }
    }

    case Constants.FILTER_REMOVE: {
      const keys = action.keys

      if ( !state[group] ) {
        return state
      }

      if ( keys == null || keys.length === 0 ) {
        return state
      }

      return {
        ...state,
        [group] : Object
          .keys( state[group] )
          .reduce( ( prev, curr ) => {
            if ( keys.indexOf( curr ) !== -1 ) {
              return prev
            }

            return {
              ...prev,
              [curr] : state[group][curr]
            }
          }, {} )
      }
    }

    case Constants.FILTER_CLEAR: {
      const nState = { ...state }
      const curr = state[group] || {}

      if ( Object.keys( curr ).length === 0 ) {
        return state
      }

      nState[group] = {}

      return nState
    }

    case Constants.FILTER_CLEAR_ALL: {
      return initialState
    }

    default:
      return state
  }

}

function get( state, group ) {
  return ( state && state[group] ) || null
}

export {
  get
}

export default filter
